import type { PayloadAction } from '@reduxjs/toolkit';
import { createSnapQuoteAssignment } from '@ui/features/quote-builder/state/endpoints/create-snap-quote-assignment';
import type { ExtraReducerBuilder } from '@ui/features/quote-builder/types/shared';
import type { WritableQuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

/**
 * After successfully creating a new assignment, update the `currentAssignment`
 * in quote builder state to reflect the newly created assignment.
 */
function createSnapQuoteAssignmentFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof createSnapQuoteAssignment.Types.ResultType>,
) {
  state.currentAssignment = action.payload;
}

export function createSnapQuoteAssignmentReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(
    createSnapQuoteAssignment.matchFulfilled,
    createSnapQuoteAssignmentFulfilled,
  );
}
